import React from 'react';
import PropTypes from 'prop-types';

import {withIsOpenState} from '../../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEStdModalController from '../../../modals/oe-std-modal-controller';
import {OECarouselItem, OECarousel} from '../../../elements/oe-carousel';
import OEPlyr from '../../../elements/oe-plyr';
import {OEDefaultConfigFactory} from '../../../oe-default-configs';
import OEStartViewStdHeaderFactory from './oe-start-view-std-header-factory';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import LocalStorage from '../../../../lib/tools/local-storage';

class OEStartViewStdVideoItem extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onRef = this.onRef.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.active != this.props.active && !nextProps.active && this.ref)  {
            this.ref.pause();
        }
    }

    onRef(ref) {
        this.ref = ref;
        if(!this.props.active && this.ref)  this.ref.pause();
    }

    render()    {
        return (
            <OEPlyr
                src={this.props.src}
                ref={this.onRef}
            />
        );
    }
};

OEStartViewStdVideoItem.defaultProps = {
    active: false
};

OEStartViewStdVideoItem.propTypes = {
    src: PropTypes.string,
    active: PropTypes.bool
};

export class OEStartViewStd extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                back: 'Back',
                next: 'Next'
            },
            activeIndex: 0,
            items: this.getItems()
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.previous = this.previous.bind(this);
        this.next = this.next.bind(this);
    }

    getItems(props)   {
        props = props || this.props;

        let items = new Array();

        if(typeof(props.config) !== 'undefined' && typeof(props.config.videoContent) === 'string' && props.config.videoContent !== '')    {
            items.push({type: 'video', src: props.config.videoContent});
        }

        let langCode = this.oe.isReady() ? this.oe.sharedInterface.getUIControllerSettings().getLanguageCode() : 'en';
        langCode = langCode.toLowerCase();
        
        for(let i = 1; i < 5; ++i)    {
            const itemSrc = 'images/start/' + langCode + '/ui_maus_0' + i.toString() + '.png';
            items.push({type: 'image', src: itemSrc});
        }
    
        for(let i = 1; i < 4; ++i)    {
            const itemSrc = 'images/start/' + langCode + '/ui_touch_0' + i.toString() + '.png';
            items.push({type: 'image', src: itemSrc});
        }

        return items;
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.config, this.props.config, true))  {
            this.setState({items: this.getItems(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onTimeout() {
        let config = this.props.config || OEDefaultConfigFactory.startView();

        if(config.showAtStartUp && this.oe.isReady() && LocalStorage.getItem('dontShowStartViewAtStartUp') !== 'true' && this.props.openState)   {
            this.props.openState.setOpen(true);
        }
    }

    updateLanguage()   {
        this.setState({
            strings: {
                back: this.oe.sharedInterface.getLocalizedStringEnc('start_view_back'),
                next: this.oe.sharedInterface.getLocalizedStringEnc('start_view_next')
            },
            items: this.getItems()
        }); 
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }
        this.updateLanguage();
    }

    renderCarouselItemContent(item, index) {
        if(item.type === 'image')   {
            return <img src={item.src}/>;
        }
        
        if(item.type === 'video')    {
            return (
                <OEStartViewStdVideoItem
                    src={item.src}
                    active={index === this.state.activeIndex}
                />
            );
        }

        return null;
    }

    renderCarouselItem(item, index) {
        return (
            <OECarouselItem key={index}>
                {this.renderCarouselItemContent(item, index)}
            </OECarouselItem>
        );
    }

    renderCarousel()  {
        const slides = this.state.items.map((item, index) => this.renderCarouselItem(item, index));
        return (
            <OECarousel activeIndex={this.state.activeIndex}>
                {slides}
            </OECarousel>
        );
    }

    renderContent() {
        const isFirst = this.state.activeIndex === 0;
        const isLast = this.state.activeIndex === this.state.items.length - 1;
        const indicatorActive = this.state.activeIndex + 1;
        const indicatorNum = this.state.items.length;

        return (
            <div className="aspect-dummy" >
                {this.renderCarousel()}

                <a 
                    className={'carousel-control-prev carousel-control-btn themecolor' + (isFirst ? ' disabled' : '')}
                    role="button" 
                    onClick={this.previous}
                >
                    <span>{this.state.strings.back}</span>
                </a>

                <a 
                    className={'carousel-control-next carousel-control-btn themecolor' + (isLast ? ' disabled' : '')}
                    role="button" 
                    onClick={this.next}
                >
                    <span>{this.state.strings.next}</span>
                </a>

                <div className="carousel-indicators">
                    {indicatorActive.toString() + '/' + indicatorNum.toString()}
                </div>
            </div>
        );
    }

    render() {
        let config = this.props.config || OEDefaultConfigFactory.startView();

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    headerStringId="start_view"
                    className="start-view-std"
                    isOpen={this.props.isOpen}
                    onToggle={this.props.onToggle}
                    logo={config.logo}
                >
                
                    <OEStartViewStdHeaderFactory moduleId={this.props.moduleId} target={this.props.target} config={this.props.config}/>

                    {this.renderContent()}

                </OEStdModalController>
            </React.Fragment>
        );
    }

    next() {
        if(this.state.activeIndex === this.state.items.length - 1) return;
        const nextIndex = this.state.activeIndex === this.state.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex});
    }

    previous() {
        if(this.state.activeIndex === 0) return;
        const nextIndex = this.state.activeIndex === 0 ? this.state.items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex});
    }
}

OEStartViewStd.defaultProps = {
    moduleId: ''
};

OEStartViewStd.propTypes = {
    moduleId: PropTypes.string,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
};

export default withIsOpenState(OEStartViewStd);